import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { validateRut, formatterRut, numberToClp } from 'chilean-formatter';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.scss']
})
export class EmpresasComponent implements OnInit {

  uploadedFile: any
  uploadedFiles: any[] = []
  fotos: any[] = [];
  @ViewChild('fileUpload') fileUpload: any;

  usuario: any;
  empresas: any[];
  empresa: any

  estaEditando: boolean = false;
  modoCreaEdita: boolean = false;
  formulario: FormGroup;
  paises: any;

  logo: string = 'https://clientes.controlguard.cl/assets/img/controlguard_247_80.png';
  logoPreview: string | null = null;
  usaLogoPropio: boolean = false;
  guardando: boolean = false;

  esCCZ: boolean = false;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    if (this.usuario.Email == 'ccerdaz@gmail.com')
      this.esCCZ = true;

    this.formulario = this.formBuilder.group({
      _id: '',
      RutEmpresa: '',
      NombreEmpresa: ['', Validators.required],
      NombreContacto: ['', Validators.required],
      Pais: '',
      EmailContacto: ['', Validators.required],
      FonoContacto: '',
      Habilitado: true,
      UsaLogoPropio: false,
      DeudaVencida: true,
      Giro: '',
      Direccion: '',
    });

    this.paises = [];
    this.getConfiguracionesPaises();
    this.getEmpresas();
  }

  async ngOnInit(): Promise<void> {
    console.log('ngOnInit');
  }

  async getConfiguracionesPaises(): Promise<void> {
    const data = await this.http.getConfiguracionesPaisesService() || [];
    this.paises = data.sort((a, b) => (a.Pais || '').localeCompare(b.Pais || ''));
    console.log('paises', this.paises);
  }

  nuevo() {
    console.log('pasó por nuevo');

    this.estaEditando = false
    this.modoCreaEdita = true

    this.formulario.controls.Habilitado.setValue(true)
    this.formulario.controls.DeudaVencida.setValue(false)
    this.formulario.controls.Pais.setValue('CHILE')



    // Resetear logo
    this.limpiarLogo();
  }

  limpiarLogo() {
    if (this.logoPreview) {
      URL.revokeObjectURL(this.logoPreview);
      this.logoPreview = null;
    }
    this.uploadedFile = null;
    this.logo = 'https://clientes.controlguard.cl/assets/img/controlguard_247_80.png';
    this.usaLogoPropio = false;
  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteEmpresaService(id)
          .subscribe((data: any) => {
            console.log(data);
            this.getEmpresas();
          })
        this.messageService.add({
          severity: "info",
          summary: "Listo",
          detail: "El registro ha sido eliminado"
        });
      },
      reject: () => {
        return;
      }
    });
  }

  formateaRUT() {
    this.formulario.controls.RutEmpresa.setValue(formatterRut(this.formulario.controls.RutEmpresa.value))

    if (!validateRut(this.formulario.controls.RutEmpresa.value))
      this.formulario.controls.RutEmpresa.setErrors({ 'incorrect': true })
  }

  validarArchivo(file: File): boolean {
    // Verificar tipo
    if (file.type !== 'image/png') {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Solo se permiten archivos PNG'
      });
      return false;
    }

    // Verificar tamaño (por ejemplo, máximo 1MB)
    const maxSize = 1 * 1024 * 1024; // 1MB
    if (file.size > maxSize) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'El archivo es demasiado grande. Máximo 1MB.'
      });
      return false;
    }

    return true;
  }

  async getEmpresas(): Promise<void> {
    console.log('getEmpresas');

    this.empresas = await this.http.getEmpresaService();

    console.log('empresas', this.empresas);

    // const sinInstalaciones = aux.empresasSinInstalaciones

    // this.empresas = this.empresas.map(empresa => ({
    //   ...empresa,
    //   sinInstalacion: sinInstalaciones.some(emp => emp._id === empresa._id),
    // }));

    //Para revisión
    this.empresas.forEach(element => {
      if (element.NombreEmpresa == 'TRESUR SPA')
        console.log('element', element);

    });

    //const nn = this.empresas.filter(e => e.sinInstalacion)

    //console.log('nn', nn);

    this.ngZone.run(() => { })
  }

  archivoSeleccionado(event) {
    console.log('archivoSeleccionado', event);

    if (event.files && event.files.length > 0) {
      const file = event.files[0];

      if (this.validarArchivo(file)) {
        this.uploadedFile = file;

        // Crear previsualización usando FileReader para mayor compatibilidad
        const reader = new FileReader();
        reader.onload = (e: any) => {
          // Liberar la URL anterior si existe
          if (this.logoPreview) {
            URL.revokeObjectURL(this.logoPreview);
          }

          // Usar el resultado del FileReader como URL de la imagen
          this.logo = e.target.result;
          console.log('Logo preview set:', this.logo);

          // Forzar detección de cambios si es necesario
          this.ngZone.run(() => { });

          // Notificar al usuario
          this.messageService.add({
            severity: 'success',
            summary: 'Logo cargado',
            detail: 'Imagen seleccionada correctamente'
          });
        };

        // Leer el archivo como URL de datos
        reader.readAsDataURL(file);
      } else {
        // Limpiar selección si no es válido
        this.fileUpload.clear();
      }
    }
  }

  selectaLogoPropio(event) {
    console.log('selectaLogoPropio', event);
    this.usaLogoPropio = event.checked;

    // Si se desmarca la opción, limpiar la previsualización
    if (!this.usaLogoPropio) {
      this.limpiarLogo();
    }
  }

  guardar(_formValue) {
    this.guardando = true;
    let formValue = JSON.parse(JSON.stringify(_formValue));

    // Limpieza de campos
    formValue.NombreEmpresa = formValue.NombreEmpresa.trim();
    formValue.NombreContacto = formValue.NombreContacto.trim();
    formValue.EmailContacto = formValue.EmailContacto.trim();
    formValue.FonoContacto = formValue.FonoContacto ? formValue.FonoContacto.trim() : '';
    formValue.Giro = formValue.Giro ? formValue.Giro.trim() : '';
    formValue.Direccion = formValue.Direccion ? formValue.Direccion.trim() : '';

    console.log('formValue', formValue);


    // Verificación para el caso de nuevo con logo (solo aplica al crear, no al editar)
    if (!this.estaEditando && formValue.UsaLogoPropio && !this.uploadedFile) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Ha seleccionado usar logo propio pero no ha cargado ninguna imagen'
      });
      this.guardando = false;
      return;
    }

    // Crear un FormData para enviar tanto los datos como el archivo
    const formData = new FormData();

    // Agregar todos los campos del formulario al FormData
    Object.keys(formValue).forEach(key => {
      formData.append(key, formValue[key]);
    });

    // Si hay un logo, agregarlo al FormData
    if (this.uploadedFile && formValue.UsaLogoPropio) {
      formData.append('logo_branded', this.uploadedFile, this.uploadedFile.name);
    }

    // Si estamos editando una empresa existente
    if (this.estaEditando) {
      // Mantenemos el código original para edición
      this.http.updateEmpresaConLogoService(formData).subscribe(
        (data: any) => {
          console.log('data', data);
          this.getEmpresas();
          this.messageService.add({
            severity: 'success',
            summary: 'Listo!',
            detail: 'Cliente editado'
          });

          this.modoCreaEdita = false;
          this.estaEditando = false;
          this.limpiaFormulario();
          this.guardando = false;
        },
        err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error!',
            detail: err.error
          });
          this.guardando = false;
        }
      );
      return;
    }

    // Enviar todo en una sola petición
    this.http.newEmpresaConLogoService(formData).subscribe(
      (data: any) => {
        console.log('Empresa creada:', data);
        this.getEmpresas();

        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: formValue.UsaLogoPropio
            ? 'Empresa creada con logo personalizado'
            : 'Registro creado'
        });

        this.modoCreaEdita = false;
        this.limpiaFormulario();
        this.guardando = false;
      },
      err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
        this.guardando = false;
      }
    );
  }

  abreModaledita(id) {
    console.log('id:', id);

    this.estaEditando = true;
    this.modoCreaEdita = true;
    let index = this.empresas.findIndex(e => e._id == id);

    this.empresa = this.empresas[index];
    console.log('empresa', this.empresa);
    this.formulario.patchValue(this.empresa);

    this.usaLogoPropio = this.empresa.UsaLogoPropio;

    const cacheBuster = this.empresa.updatedAt
      ? new Date(this.empresa.updatedAt).getTime()
      : Date.now();
    const logoTemp = 'https://clientes.controlguard.cl/assets/logosClientes/' + this.empresa._id + '/logo_branded.png?v=' + cacheBuster;
    const defaultLogo = 'https://clientes.controlguard.cl/assets/img/controlguard_247_80.png';

    // Inicializar logo con valor por defecto para evitar errores
    this.logo = defaultLogo;

    // Solo intentar cargar el logo personalizado si el usuario ha marcado "Logo propio"
    if (this.usaLogoPropio) {
      // Crear elemento de imagen para verificar
      const img = new Image();

      img.onload = () => {
        console.log('Logo cargado correctamente:', logoTemp);
        // Si carga bien, actualizamos la propiedad que usa el template
        this.logo = logoTemp;
        // Forzar detección de cambios si estás usando ChangeDetectorRef
        // this.cdr.detectChanges();
      };

      img.onerror = () => {
        console.error('Logo no encontrado, usando logo por defecto');
        // En caso de error, asegurarnos de que se use el logo por defecto
        this.logo = defaultLogo;
        // Forzar detección de cambios si estás usando ChangeDetectorRef
        // this.cdr.detectChanges();
      };

      // Iniciar la carga de la imagen
      img.src = logoTemp;
    } else {
      // Si no usa logo propio, usar siempre el default
      this.logo = defaultLogo;
    }
  }

  limpiaFormulario() {
    this.formulario.reset()
    this.modoCreaEdita = false
    this.estaEditando = false
    this.uploadedFile = null
  }

}